import { initArticleToc } from './ui/article_toc'
import { initBottomCvArea, initSharedPageInteractions, initSmoothAnchorLinks, syncChangedActionForm } from './shared_page_interactions'
import './tail-clamp-init'
import { initArticleCompanyCta } from './article_company_cta'

export { initArticleToc, initBottomCvArea, initSmoothAnchorLinks, syncChangedActionForm }

export function initArticleSingle() {
  initSharedPageInteractions({ smoothAnchorLinks: 'all' })
  initArticleToc()
  initArticleCompanyCta()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArticleSingle)
} else {
  initArticleSingle()
}
